<vault-alert type="warning">{{
  'app.no_search_results' | translate
}}</vault-alert>
